import React from "react";
import { Box, Card, CardContent, Skeleton, Typography, useMediaQuery, useTheme } from "@mui/material";

const SkeletonLoader: React.FC = () => {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Card sx={{ width: isMobile ? '95%' : '65%', margin: "2rem auto", padding: "1rem" }}>
            <Skeleton variant="rectangular" height={300} width="100%" />

            <CardContent>
                <Typography variant="h3">
                    <Skeleton width="80%" />
                </Typography>

                <Box display="flex" gap={2} marginTop="1rem">
                    <Skeleton variant="circular" width={40} height={40} />
                    <Box>
                        <Skeleton width={120} height={20} />
                        <Skeleton width={80} height={15} />
                    </Box>
                </Box>
                <Box marginTop="2rem">
                    <Typography variant="body1">
                        <Skeleton width="100%" />
                        <Skeleton width="95%" />
                        <Skeleton width="90%" />
                        <Skeleton width="85%" />
                        <Skeleton width="80%" />
                    </Typography>
                    <Box mt={3}>
                        <Skeleton width="95%" />
                        <Skeleton width="90%" />
                        <Skeleton width="100%" />
                        <Skeleton width="70%" />
                    </Box>
                    <Box mt={3}>
                        <Skeleton width="95%" />
                        <Skeleton width="90%" />
                        <Skeleton width="100%" />
                        <Skeleton width="70%" />
                    </Box>
                    <Box mt={3}>
                        <Skeleton width="95%" />
                        <Skeleton width="90%" />
                        <Skeleton width="100%" />
                        <Skeleton width="70%" />
                    </Box>
                </Box>
            </CardContent>
        </Card>
    );
};

export default SkeletonLoader;
